module.exports = __webpack_public_path__ + "img/gradient-mobile.dbb0966d.svg";